var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('b-button',{staticClass:" my-1 mx-1",attrs:{"variant":"info"},on:{"click":_vm.transmit}},[_vm._v("Auf Website übertragen")]),_c('page2wordpress',{ref:"p2w"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }